import type { IWorkJourneyMatrixCell } from '@src/models/interfaces/workJourneyManagement.interface';

export const SHIFT_REPLACEMENT_EXCEPTION_TYPE = 'shift_replacement';

export type ReplacementCellSource = Partial<
  Pick<IWorkJourneyMatrixCell, 'kind' | 'code' | 'exceptionType' | 'observation'>
>;

/**
 * A covered day keeps the REM chip only while the coverage attendance record
 * does not exist; once it does, the cell turns into PRE/WORK and the fact that
 * it is a replacement survives just in the exception fields.
 *
 * Includes `replacement_out` (substitute's home journey) so undo/remove works
 * from both the cover row and the substitute row.
 */
export const isReplacementCell = (cell?: ReplacementCellSource | null): boolean =>
  cell?.kind === 'replacement' ||
  cell?.kind === 'replacement_out' ||
  cell?.code === 'REM' ||
  cell?.exceptionType === SHIFT_REPLACEMENT_EXCEPTION_TYPE ||
  cell?.observation === SHIFT_REPLACEMENT_EXCEPTION_TYPE;
